import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app";
import { Providers } from "@/components/atoms/providers";
import { ErrorBoundary } from "@/components/global/error-boundary";
import "@/i18n";
import { installGlobalErrorReporting } from "@/logger/global-errors";
import "@/styles/index.css";
import "@/styles/tailwind/index.css";
import "@/utils/polyfills/crypto-random-uuids";
import "@/utils/polyfills/form-request-submit";

// Before anything else renders: a throw during boot is exactly the kind that used to vanish.
installGlobalErrorReporting();

defineCustomElements(window);

const container = document.getElementById("root");
const root = createRoot(container!);

/**
 * The outermost boundary has to be out here, above `Providers`.
 *
 * `App` has one of its own, but it is inside `App`'s return — so it never sees a throw from the
 * eleven providers wrapped around it, from `App`'s own hooks, or from the branch `App` returns
 * before reaching it. React 18 answers an uncaught render error by unmounting the entire root,
 * which is the white, frozen screen this boundary exists to replace. It can only do that job from
 * above everything that can throw.
 */
root.render(
  <StrictMode>
    <ErrorBoundary>
      <Providers>
        <App />
      </Providers>
    </ErrorBoundary>
  </StrictMode>,
);
